import { SET_TOAST_INFORMATION_SUCCESS, SET_CLOSE_TOAST_SUCCESS } from './UserNotificationToast.actions'

const initialState = {
  open: false,
  message: '',
  severity: 'default',
  handleClose: () => undefined
}

/**
 * The reducer for the Toast
 */
const userNotificationReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SET_TOAST_INFORMATION_SUCCESS: {
      return {
        ...state,
        open: payload.open,
        message: payload.message,
        severity: payload.severity,
        handleClose: payload.handleClose
      }
    }
    case SET_CLOSE_TOAST_SUCCESS: {
      return {
        ...state,
        open: false,
        severity: 'default',
        message: '',
        handleClose: () => undefined
      }
    }
    default: {
      return state
    }
  }
}

export default userNotificationReducer
